<template>
  <div class="admin-layout">
    <!-- 侧边栏 -->
    <div class="sidebar" :class="{ collapsed: isCollapse }">
      <div class="logo-container">
        <!-- <img src="@/assets/logo.jpg" alt="Logo" class="logo-img"> -->
        <span v-show="!isCollapse" class="logo-text">教育后台管理</span>
      </div>

      <el-menu :default-active="activeMenu" class="sidebar-menu" :collapse="isCollapse" background-color="#001529"
        text-color="#fff" active-text-color="#409EFF">
        <el-menu-item index="/admin/home" @click="handleMenuClick('/admin/home')">
          <el-icon>
            <HomeFilled />
          </el-icon>
          <span>首页</span>
        </el-menu-item>

        <el-sub-menu index="account">
          <template #title>
            <el-icon>
              <UserFilled />
            </el-icon>
            <span>系统账号管理</span>
          </template>
          <el-menu-item index="/admin/account/profile" @click="handleMenuClick('/admin/account/profile')">
            修改个人信息
          </el-menu-item>
          <el-menu-item index="/admin/account/password" @click="handleMenuClick('/admin/account/password')">
            修改账号密码
          </el-menu-item>
          <el-menu-item index="/admin/account/admin" @click="handleMenuClick('/admin/account/admin')">
            管理员管理
          </el-menu-item>
          <el-menu-item index="/admin/account/school" @click="handleMenuClick('/admin/account/school')">
            学校账号管理
          </el-menu-item>
          <el-menu-item index="/admin/account/student" @click="handleMenuClick('/admin/account/student')">
            学生账号管理
          </el-menu-item>
          <el-menu-item index="/admin/account/role" @click="handleMenuClick('/admin/account/role')">
            角色管理
          </el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="course">
          <template #title>
            <el-icon>
              <Reading />
            </el-icon>
            <span>课程管理</span>
          </template>
          <el-menu-item index="/admin/course/category" @click="handleMenuClick('/admin/course/category')">
            课程分类
          </el-menu-item>
          <el-menu-item index="/admin/course/template" @click="handleMenuClick('/admin/course/template')">
            院校课程模板
          </el-menu-item>
          <el-menu-item index="/admin/course/questionbank" @click="handleMenuClick('/admin/course/questionbank')">
            试题题库
          </el-menu-item>
          <el-menu-item index="/admin/course/opencourse" @click="handleMenuClick('/admin/course/opencourse')">
            公开课
          </el-menu-item>
          <el-menu-item index="/admin/course/opencourse-review" @click="handleMenuClick('/admin/course/opencourse-review')">
            公开课审核
          </el-menu-item>
          <el-menu-item index="/admin/homepage/topic" @click="handleMenuClick('/admin/homepage/topic')">
            首页专题
          </el-menu-item>
        </el-sub-menu>
        <el-sub-menu index="content">
          <template #title>
            <el-icon>
              <Document />
            </el-icon>
            <span>信息管理</span>
          </template>
          <el-menu-item index="/admin/content/news" @click="handleMenuClick('/admin/content/news')">
            教学新闻
          </el-menu-item>
          <el-menu-item index="/admin/content/live-video" @click="handleMenuClick('/admin/content/live-video')">
            视频直播
          </el-menu-item>
          <el-menu-item index="/admin/content/document" @click="handleMenuClick('/admin/content/document')">
            文档管理
          </el-menu-item>
          <el-menu-item index="/admin/content/feedback" @click="handleMenuClick('/admin/content/feedback')">
            意见反馈
          </el-menu-item>
          <el-menu-item index="/admin/content/banner" @click="handleMenuClick('/admin/content/banner')">
            首页Banner管理
          </el-menu-item>
        </el-sub-menu>

        <el-sub-menu index="settings">
          <template #title>
            <el-icon>
              <Setting />
            </el-icon>
            <span>系统设置</span>
          </template>
          <el-menu-item index="/admin/settings/school" @click="handleMenuClick('/admin/settings/school')">
            学校管理
          </el-menu-item>
          <el-menu-item index="/admin/settings/website" @click="handleMenuClick('/admin/settings/website')">
            网站基本设置
          </el-menu-item>
        </el-sub-menu>
      </el-menu>
    </div>

    <!-- 主体内容区 -->
    <div class="main-container" :class="{ 'main-expanded': isCollapse }">
      <!-- 顶部导航 -->
      <div class="navbar">
        <div class="navbar-left">
          <el-button type="text" class="toggle-button" @click="toggleSidebar">
            <el-icon :size="20">
              <component :is="isCollapse ? 'Expand' : 'Fold'" />
            </el-icon>
          </el-button>
          <breadcrumb />
        </div>

        <div class="navbar-right">
          <!-- <el-tooltip effect="dark" content="全屏" placement="bottom">
            <el-button type="text" class="right-menu-item" @click="toggleFullScreen">
              <el-icon :size="18">
                <FullScreen />
              </el-icon>
            </el-button>
          </el-tooltip> -->
          <el-button type="text" class="right-menu-item" @click="jumpToDashboard">
            教学云图
          </el-button>
          <el-button type="text" class="right-menu-item" @click="jumpToSchoolSelect">
            切换学校
          </el-button>
          <el-dropdown trigger="click" class="avatar-container">
            <div class="avatar-wrapper">
              <el-avatar :size="32" :src="defaultAvatar" />
              <span class="user-name" :title="formData.name">{{ formData.name || '管理员' }}</span>
              <el-icon class="el-icon-arrow">
                <CaretBottom />
              </el-icon>
            </div>
            <template #dropdown>
              <el-dropdown-menu>
                <el-dropdown-item @click="handleCommand('profile')">
                  <el-icon>
                    <User />
                  </el-icon>个人信息
                </el-dropdown-item>
                <el-dropdown-item @click="handleCommand('password')">
                  <el-icon>
                    <Lock />
                  </el-icon>修改密码
                </el-dropdown-item>
                <el-dropdown-item divided @click="handleCommand('logout')">
                  <el-icon>
                    <SwitchButton />
                  </el-icon>退出登录
                </el-dropdown-item>
              </el-dropdown-menu>
            </template>
          </el-dropdown>
        </div>
      </div>

      <!-- 内容区域 -->
      <div class="app-main">
        <router-view v-slot="{ Component }">
          <transition name="fade-transform" mode="out-in">
            <component :is="Component" />
          </transition>
        </router-view>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, reactive, onMounted, watch } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { ElMessageBox } from 'element-plus'
import { useUserStore } from '@/stores/user'

import Breadcrumb from '../Breadcrumb.vue'

const router = useRouter()
const route = useRoute()
const userStore = useUserStore()

// 定义默认头像
const defaultAvatar = ref('https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png')
const formData = reactive({
  id: '',
  name: '',
  avatar: '',
})

// 从Pinia store获取用户信息并更新formData
const updateUserInfoFromStore = () => {
  try {
    const userInfo = userStore.userInfo
    console.log('从store获取的用户信息:', userInfo)
    
    if (userInfo && Object.keys(userInfo).length > 0) {
      // 更新formData
      formData.id = userInfo.id || ''
      formData.name = userInfo.name || userInfo.account || ''
      formData.avatar = userInfo.avatar || ''
      
      // 更新头像 - 确保头像URL有效
      if (userInfo.avatar && userInfo.avatar.trim() !== '') {
        defaultAvatar.value = userInfo.avatar
      } else {
        // 如果没有头像，使用默认头像
        defaultAvatar.value = 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
      }
      
      console.log('更新后的formData:', formData)
      console.log('更新后的头像:', defaultAvatar.value)
    } else {
      console.warn('store中没有用户信息或用户信息不完整')
    }
  } catch (error) {
    console.error('获取用户信息时发生错误:', error)
  }
}

// 监听store中userInfo的变化
watch(
  () => userStore.userInfo,
  (newUserInfo) => {
    console.log('用户信息已更新:', newUserInfo)
    updateUserInfoFromStore()
  },
  { deep: true }
)

onMounted(() => {
  // 在组件挂载时从store获取用户信息
  updateUserInfoFromStore()
  
  // 如果store中没有用户信息，尝试从localStorage直接获取
  if (!formData.name && !formData.avatar) {
    try {
      const userInfoStr = localStorage.getItem('userInfo')
      if (userInfoStr) {
        const userInfo = JSON.parse(userInfoStr)
        if (userInfo) {
          console.log('从localStorage直接获取用户信息:', userInfo)
          // 更新formData
          formData.id = userInfo.id || ''
          formData.name = userInfo.name || userInfo.account || ''
          formData.avatar = userInfo.avatar || ''
          
          // 更新头像
          if (userInfo.avatar && userInfo.avatar.trim() !== '') {
            defaultAvatar.value = userInfo.avatar
          }
        }
      }
    } catch (error) {
      console.error('从localStorage获取用户信息失败:', error)
    }
  }
  
  console.log('初始化用户信息:', formData)
  console.log('默认头像:', defaultAvatar)
})

// 侧边栏折叠状态
const isCollapse = ref(false)

// 当前激活的菜单
const activeMenu = computed(() => {
  // 如果是课程模板详情页面，保持院校课程模板菜单项的选中状态
  if (route.path.startsWith('/admin/course/template/')) {
    return '/admin/course/template'
  }
  return route.path
})

// 切换侧边栏
const toggleSidebar = () => {
  isCollapse.value = !isCollapse.value
}

// 菜单点击处理
const handleMenuClick = (path) => {
  // 如果不是跳转到首页，清除自动跳转标记
  if (path !== '/admin/home') {
    sessionStorage.removeItem('adminRedirectFlag')
  }
  router.push(path)
}

// 跳转学校选择页面
const jumpToSchoolSelect = () => {
  // 清除自动跳转标记，防止跳转回首页
  sessionStorage.removeItem('adminRedirectFlag')
  // 新标签页跳转学校选择页面
  window.open('/school', '_blank')
}

// 跳转教学云图页面
const jumpToDashboard = () => {
  // 清除自动跳转标记，防止跳转回首页
  sessionStorage.removeItem('adminRedirectFlag')
  // 新标签页跳转教学云图页面
  window.open('/dashboard', '_blank')
}

// 全屏切换
const toggleFullScreen = () => {
  if (!document.fullscreenElement) {
    document.documentElement.requestFullscreen()
  } else {
    document.exitFullscreen()
  }
}

// 用户下拉菜单命令处理
const handleCommand = (command) => {
  switch (command) {
    case 'profile':
      // 清除自动跳转标记，防止跳转回首页
      sessionStorage.removeItem('adminRedirectFlag')
      router.push('/admin/account/profile')
      break
    case 'password':
      // 清除自动跳转标记，防止跳转回首页
      sessionStorage.removeItem('adminRedirectFlag')
      router.push('/admin/account/password')
      break
    case 'logout':
      ElMessageBox.confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        // 直接清除本地状态并跳转，不调用logout API
        // 避免因API返回403而显示"登录已过期"的提示
        userStore.logout()
        // 重置头像和用户名
        defaultAvatar.value = 'https://cube.elemecdn.com/0/88/03b0d39583f48206768a7534e55bcpng.png'
        formData.name = '管理员'
        formData.avatar = ''
        // 跳转到管理员登录页
        router.push('/admin/login').then(() => {
          // 清除localStorage中的用户信息
          window.location.reload() // 刷新页面以确保状态清除
        })
      })
      break
    default:
      router.push('/admin/home')
  }
}
</script>

<style scoped>
.admin-layout {
  display: flex;
  height: 100vh;
  background-color: #f0f2f5;
}

.sidebar {
  width: 220px;
  height: 100%;
  background-color: #001529;
  transition: width 0.3s;
  overflow-x: hidden;
  box-shadow: 2px 0 6px rgba(0, 21, 41, 0.35);
}

.sidebar.collapsed {
  width: 60px;
}

.logo-container {
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  overflow: hidden;
  background: #002140;
}

.logo-img {
  width: 32px;
  height: 32px;
  margin-right: 12px;
}

.logo-text {
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  white-space: nowrap;
  opacity: 1;
  transition: opacity 0.3s;
}

.sidebar-menu {
  border-right: none;
}

.sidebar-menu:not(.el-menu--collapse) {
  width: 220px;
}

.main-container {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  background: #f0f2f5;
  transition: margin-left 0.3s;
}

.navbar {
  height: 60px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(173, 216, 200, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 16px;
}

.navbar-left {
  display: flex;
  align-items: center;
}

.toggle-button {
  padding: 0 12px;
  height: 100%;
  font-size: 16px;
  cursor: pointer;
  transition: background 0.3s;
}

.toggle-button:hover {
  background: rgba(0, 0, 0, 0.025);
}

.navbar-right {
  display: flex;
  align-items: center;
}

.right-menu-item {
  padding: 0 12px;
  cursor: pointer;
  transition: background 0.3s;
}

.right-menu-item:hover {
  background: rgba(0, 0, 0, 0.025);
}

.avatar-container {
  margin-left: 12px;
  cursor: pointer;
}

.avatar-wrapper {
  display: flex;
  align-items: center;
  padding: 0 12px;
}

.user-name {
  margin: 0 8px;
  font-size: 14px;
  color: rgba(0, 0, 0, 0.85);
}

.app-main {
  flex: 1;
  padding: 10px 16px 16px 16px;
  overflow-y: auto;
}

/* 路由切换动画 */
.fade-transform-enter-active,
.fade-transform-leave-active {
  transition: all 0.3s;
}

.fade-transform-enter-from {
  opacity: 0;
  transform: translateX(-30px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
